import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { PunchCardRedeem } from '../../models/punch-card-redeem';
import { PunchCard } from '../../models/punch-card';

import { BusinessUserOfferManagerHandler } from '../../providers/business-user-offer-handler';
import { ConsumerHandlerProvider } from '../../providers/consumer-handler';

import { Globals } from '../../providers/globals';

/**
 * Generated class for the BusinessOfferRedeemPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-business-offer-redeem',
  templateUrl: 'business-offer-redeem.html',
})
export class BusinessOfferRedeemPage {
  offerRedeem: any;
  offer: any;
  offerInfo: any;
  scannedIds: any;
  hasOffer: boolean;
  filePath: any;
  loader: any;
  isLoading: boolean = false;
  offerRefreshDone: boolean = false;
  leftView: boolean = false;
  isRedeemed: boolean = false;  
  isRedeeming: boolean = false;

  constructor(
  	public navCtrl: NavController, 
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public consumerHandlerProvider: ConsumerHandlerProvider,
    public businessUserOfferManagerHandler: BusinessUserOfferManagerHandler,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public globals: Globals,
    public actionSheetCtrl: ActionSheetController) {
  	
  	this.offerInfo = navParams.get('offerRedeem');

    console.log("HOLA I AM IN HERE SENOR");

    this.offerRedeem = {
      OfferId: parseInt(this.offerInfo[0]),
      UserId: parseInt(this.offerInfo[1])
    };

    this.consumerHandlerProvider.currentIdentityUserId = this.offerRedeem.UserId;

    this.isLoading = true;

    this.loadOffer(true);
  }

  loadOffer(displayErr){
    this.businessUserOfferManagerHandler.getOffer({
      offerId: this.offerRedeem.OfferId,
      userId: this.offerRedeem.UserId,
      cb:(result)=>{
        if(!displayErr) return;

        if(result.Success){
          console.log("HOLA I AM IN CALLBACK");

          console.log(result.Data);

          this.offer = result.Data[0];

          this.isRedeemed = this.offer.RedeemedDate ? true : false;
          
          if(!this.offerRefreshDone){
            this.isLoading = false;      
          }     
        } else { 
          
          let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: result.Message,
              buttons: ['Ok']
            });
            
            alert.present();

            this.isLoading = false; 

            this.navCtrl.pop();
        }
      }
    })
  }

  redeem(){
    if(this.isRedeeming) return;

    this.isRedeeming = true;

    this.businessUserOfferManagerHandler.redeem({
      offerId: this.offerRedeem.OfferId,
      userId: this.offerRedeem.UserId,
      cb:(result)=>{
        if(result.Success){
          let alert = this.alertCtrl.create({
            title: 'Success',
            subTitle: 'Offer has been redeemed!',
            buttons: ['Ok']
          });

          alert.present();

          this.loadOffer(false);

          this.isRedeemed = true

          this.isRedeeming = false;
        } else { 
          
          let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: result.Message,
              buttons: ['Ok']
            });
            
            alert.present();

            this.isRedeeming = false; 
        }
      }
    })

  }

  cancelRedeem(){
    this.navCtrl.pop();
  }
}




// WEBPACK FOOTER //
// ./src/pages/business-offer-redeem/business-offer-redeem.ts